module.exports = __webpack_public_path__ + "media/components/slider/s6-2d47706285e23856e79ed0fbc5a7c471.jpg";